export const leaveTypeIds = {
  UNPAID: 5,
  Swapped: 6,
  Paternity: 4,
  Sick: 2,
  Annual: 1,
};
